<div>
  <div class="page-wrapper">
    <app-public-header></app-public-header>
    <div class="page-body-wrapper">
      <div class="page-body">
        <app-homepage-after></app-homepage-after>
      </div>
      <footer class="footer">
        <app-public-footer></app-public-footer>
      </footer>
    </div>
  </div>
</div>